"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ChildComponentManager = require("../ChildComponentManager");
var _Dialog = require("./Dialog");
var _DialogActions = require("./DialogActions");
var _DialogCloseButton = require("./DialogCloseButton");
var _DialogContent = require("./DialogContent");
var _DialogSubmitButton = require("./DialogSubmitButton");
var _DialogTitle = require("./DialogTitle");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onClose", "open", "dataCy", "loading", "scroll", "TransitionProps"],
  _excluded2 = ["onSubmit"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var GGDialog = function GGDialog(_ref) {
  var onClose = _ref.onClose,
    open = _ref.open,
    _ref$dataCy = _ref.dataCy,
    dataCy = _ref$dataCy === void 0 ? 'Dialog' : _ref$dataCy,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$scroll = _ref.scroll,
    scroll = _ref$scroll === void 0 ? 'paper' : _ref$scroll,
    _ref$TransitionProps = _ref.TransitionProps,
    TransitionProps = _ref$TransitionProps === void 0 ? {} : _ref$TransitionProps,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChildComponentManager.ChildComponentManager, {
    swapChild: false,
    onClose: onClose,
    open: open,
    children: function children(additionalProps) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, _objectSpread(_objectSpread({
        dataCy: dataCy,
        loading: loading,
        scroll: scroll,
        TransitionProps: TransitionProps
      }, props), additionalProps));
    }
  });
};
GGDialog.propTypes = {
  /**
   * 	Dialog children, usually the included sub-components.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  dataCy: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  onExited: _propTypes["default"].func,
  /**
   * If true, the component is shown.
   */
  open: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  /**
   * 	Callback fired when the component requests to be closed.
   *Signature:
   *function(event: object, reason: string) => void
   *event: The event source of the callback.
   *reason: Can be: "escapeKeyDown", "backdropClick"
   */
  onClose: _propTypes["default"].func,
  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes["default"].oneOf(['body', 'paper']),
  /**
   * If true, the dialog is full-screen.
   */
  fullScreen: _propTypes["default"].bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to false to disable maxWidth.
   */
  maxWidth: _propTypes["default"].string,
  /**
   * If true, the dialog stretches to maxWidth.
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this Transition component.
   */
  TransitionProps: _propTypes["default"].object
};
GGDialog.Actions = _DialogActions.DialogActions;
GGDialog.Content = _DialogContent.DialogContent;
var DialogTitleComponent = function DialogTitleComponent(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var _useChildComponentMan = (0, _ChildComponentManager.useChildComponentManager)(),
    onClose = _useChildComponentMan.onClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogTitle.DialogTitle, _objectSpread({
    onClose: onClose
  }, props));
};
GGDialog.Title = DialogTitleComponent;
var DialogCloseButton = function DialogCloseButton(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  var _useChildComponentMan2 = (0, _ChildComponentManager.useChildComponentManager)(),
    onClose = _useChildComponentMan2.onClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogCloseButton.DialogCloseButton, _objectSpread({
    onClose: onClose
  }, props));
};
GGDialog.CloseButton = DialogCloseButton;
var DialogSubmitButton = function DialogSubmitButton(_ref4) {
  var onSubmit = _ref4.onSubmit,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogSubmitButton.DialogSubmitButton, _objectSpread({
    onSubmit: onSubmit
  }, props));
};
GGDialog.SubmitButton = DialogSubmitButton;
var _default = exports["default"] = GGDialog;